<template>
	<el-time-select
		ref="input"
		class="input-sigarus-time-select"
		v-model="model"
		v-bind="getBind()"
		:clearable="false"
		:picker-options="{
			start: '00:00',
			step: '00:15',
			end: '23:30'
		}"
		@change="$emit('save')"
		@focus="$emit('focus')"
		@blur="$emit('blur')"
	/>
</template>

<script>
	import moment from 'moment'
	export default {
		name: 'InputSigarusTimeSelect',
		props: {
			value: {
				default: ''
			}
		},
		computed: {

			model: {

				get () { 
					return this.value ? moment(this.value,'HH:mm:ss').format('HH:mm') : ''
				},

				set (val) {
					this.$emit('input', val)
				}
			}

		},
		methods: {

			focus () { setTimeout(() => this.$refs.input.focus(), 200) },
			
			getBind () {
				delete this.$attrs.type

				return {...this.$attrs, ...this.$props}
			}
		}
	}
</script>
